require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-seren-row-construction-update.json") })
        }
      }, "path---news-seren-row-construction-update");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-seren-row-construction-update!./.cache/json/news-seren-row-construction-update.json
// module id = 845
// module chunks = 231608221292675